module.exports = __webpack_public_path__ + "static/media/Paris Cam-2.f11e0dea.webp";